import clsx from 'clsx';
import { Maybe, just, nothing } from 'maybeasy';
import { observer } from 'mobx-react';
import * as React from 'react';
import { valueFor } from '../../../../ListFilter';
import { TranslationsContext, translation } from '../../../../Translations';
import GroupParticipantsStore from '../GroupParticipantsStore/Store';

interface Props {
  groupParticipantsStore: GroupParticipantsStore;
}
interface State {
  debouncer: Maybe<ReturnType<typeof setTimeout>>;
}

class Search extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      debouncer: nothing(),
    };
  }

  handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    this.state.debouncer.do((debouncer) => clearTimeout(debouncer));

    this.props.groupParticipantsStore.updatingQuery({ key: 'query', value: event.target.value });
    this.setState({ debouncer: just(setTimeout(() => this.triggerLoading(), 1000)) });
  };

  triggerLoading = () => {
    this.setState({ debouncer: nothing() });
    this.props.groupParticipantsStore.loading();
  };

  render() {
    const { groupParticipantsStore } = this.props;
    return (
      <div className="relative w-1/2 mr-4">
        <span className="absolute inset-y-0 left-0 flex items-center pl-4">
          <svg
            fill="none"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            viewBox="0 0 24 24"
            className="w-6 h-6"
          >
            <path d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"></path>
          </svg>
        </span>
        <TranslationsContext.Consumer>
          {(ts) => (
            <input
              autoFocus
              placeholder={translation('Search Name or Email')(ts)}
              value={valueFor('query', groupParticipantsStore.searchParameters)}
              onChange={this.handleSearchChange}
              className={clsx(
                'mt-1 block w-full rounded-md border-1 border-solid',
                'border-gray-300 bg-white pl-11 py-2 text-sm font-medium',
              )}
            />
          )}
        </TranslationsContext.Consumer>
      </div>
    );
  }
}

export default observer(Search);
